import axios from "axios";
import { getDeviceToken } from "@/lib/device";

// In local dev set REACT_APP_BACKEND_URL=http://localhost:8000 to hit the dev server directly.
// In production (Vercel) leave it unset — requests go to /api which the Vercel proxy handles.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;
const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach device token on every request
api.interceptors.request.use((config) => {
  config.headers["X-Device-Token"] = getDeviceToken();
  return config;
});

export const getTopics = async () => (await api.get("/topics")).data;
export const generateWorksheet = async (payload) => (await api.post("/worksheets/generate", payload)).data;
export const getWorksheet = async (id) => (await api.get(`/worksheets/${id}`)).data;
export const gradeWorksheet = async (worksheet_id, answers) =>
  (await api.post("/worksheets/grade", { worksheet_id, answers })).data;
export const aiExplain = async (payload) => (await api.post("/ai/explain", payload)).data;
export const aiHint = async (payload) => (await api.post("/ai/hint", payload)).data;
export const reportProblem = async (payload) => (await api.post("/problems/report", payload)).data;
export const aiSolutions = async (worksheet_id) => (await api.post(`/ai/solutions?worksheet_id=${worksheet_id}`)).data;
export const aiWordProblem = async (payload) => (await api.post("/ai/word-problem", payload)).data;
// Unified worksheet builder: one free-text field (short instruction OR a long
// pasted lesson — the backend routes by size) plus up to 5 optional photos. Sent
// as multipart; the backend uses the vision chain when photos are attached.
export const aiWorksheetFromImage = async ({ files, user_input, grade_level, item_count, question_types, difficulty }) => {
  const form = new FormData();
  (files || []).forEach((f) => form.append("files", f));
  form.append("user_input", user_input || "");
  form.append("grade_level", grade_level);
  form.append("item_count", String(item_count));
  form.append("question_types", JSON.stringify(question_types || []));
  form.append("difficulty", difficulty || "Medium");
  return (await api.post("/ai/worksheet-from-image", form, { headers: { "Content-Type": "multipart/form-data" } })).data;
};
// Compile the filled-out worksheet into a PDF server-side and email it to the teacher.
export const emailWorksheetToTeacher = async (payload) =>
  (await api.post("/worksheets/email-to-teacher", payload)).data;
// Free path: pasted text -> Groq (no Anthropic cost). Same worksheet JSON shape as the PDF path.
export const aiWorksheetFromDocument = async (payload) =>
  (await api.post("/ai/worksheet-from-document", payload)).data;
export const subscribeNewsletter = async (email, source = "home") =>
  (await api.post("/newsletter/subscribe", { email, source })).data;
// ===== Auth =====
export const authRegister = async (email, password, name) =>
  (await api.post("/auth/register", { email, password, name })).data;
export const authLogin = async (email, password) =>
  (await api.post("/auth/login", { email, password })).data;
export const authLogout = async () => (await api.post("/auth/logout")).data;
export const authMe = async () => (await api.get("/auth/me")).data;

export default api;
